import { getEnv } from '@/env';
import { baseStaticUrl } from '@/utils/const';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import CryptoJS from 'crypto-js';

export interface IAxiosResp<T> {
  code: number;
  msg: string; // message
  success: boolean;
  data?: T;
  [key: string]: any;
}

const defaultConfig = {
  baseURL: ``,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (resp) => {
    return resp.data;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export interface ISrcUrl {
  key: string;
  url: string;
}
export interface ISrc {
  thumbnail: ISrcUrl;
  resource: ISrcUrl;
}

export const imgSuffix = ['.bmp', '.jpg', '.jpeg', '.png', '.gif', '.pdf'];

/**
 * decrypt some media
 * @param url
 * @param key
 */
export const decryptImgFn = async (srcInfo: ISrcUrl = { url: '', key: '' }): Promise<string> => {
  // console.log('srcInfo.url...', srcInfo.url);
  if (!srcInfo.url) {
    return '';
  }
  if (!srcInfo.key) {
    return srcInfo.url;
  }
  let encryptedImageData: any = '';
  const res = await instance.get<string>(srcInfo.url).catch(() => '');
  encryptedImageData = res;

  // 加密图片请求失败
  if (!encryptedImageData) {
    return `${baseStaticUrl}/icon-loading-fail.jpg`;
  }

  let suffix = imgSuffix.find((s) => srcInfo.url.indexOf(s) > -1);
  if (!suffix) suffix = '.png';
  // key = key.substring(key.indexOf(':') + 1);
  const iv = CryptoJS.enc.Hex.parse('0000000000000000');
  const keyStr = CryptoJS.enc.Utf8.parse(srcInfo.key);
  // debugger
  const decrypted = CryptoJS.AES.decrypt(encryptedImageData, keyStr, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const wordArray = CryptoJS.lib.WordArray.create(decrypted.words);
  const decryptedImageData = CryptoJS.enc.Base64.stringify(wordArray);
  const base64 = `data:image/${suffix.slice(1)};base64,` + decryptedImageData;
  return base64;
};
